export default __webpack_public_path__ + "static/media/noshlogo.b45bce0c.svg";